import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUserAuth } from '../context/UserAuthContext';
import AdminMenu from '../components/AdminMenu'

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('')
    const { createUser } = useUserAuth();
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await createUser(email, password);
            navigate('/login')
        } catch (e) {
            setError(e.message);
        }
    };

    return (
        <div align="left" style={{ height: "100%", padding: "30px" }} className='admin_pages'>

            <AdminMenu />

            <div>
                <h1>Register New Account</h1>
                <p className='py-2'>
                    Already have an account yet?{' '}
                    <Link to='/' className='underline'>
                        Sign in.
                    </Link>
                </p>
            </div>
            <form onSubmit={handleSubmit}>
            <div>
                <table>
                    <tr>
                        <td style={{ paddingRight: "30px" }}>
                            <label>Email Address</label>
                        </td>
                        <td>
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                className='border p-3'
                                type='email'
                                style={{height: "40px"}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ height: "20px" }}></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <label>Password</label>
                        </td>
                        <td>
                            <input
                                onChange={(e) => setPassword(e.target.value)}
                                type='password'
                                style={{ height: "40px" }}
                            />
                        </td>
                    </tr>
                </table>
            </div>
            <div style={{height: "20px"}}></div>
            <div><button className=''>Sign Up</button></div>
            </form>
        </div>
    );
};

export default Register;